export enum S1PythonModelState {
	MISSING=-3,
	START_ERROR=-1,
	INSTALL_ERROR=-2,
	NONE=0,
	SAVED=1,
	INSTALLED=2,
	RUNNING=3
}